<template>
  <div class="container-fluid py-3 px-2 px-md-4">

    <button class="btn btn-danger mt-2 ms-2 mb-3" @click="retrocedo">
      <i class="bi bi-skip-backward"></i>
    </button>

    <!-- TITULO -->
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-vcard display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            ETAPA DE SELECCION
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DATOS DE SOLICITUD
          </p>
        </div>
      </div>
    </div>

    <form action="">
      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="row gx-2 gy-2">

          <!-- APELLIDO PATERNO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person fs-6 text-warning me-2"></i> APELLIDO PATERNO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posApePaterno" />
          </div>

          <!-- APELLIDO MATERNO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person fs-6 text-primary me-2"></i> APELLIDO MATERNO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posApeMaterno" />
          </div>

          <!-- NOMBRES -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person-badge fs-6 text-warning me-2"></i> NOMBRES:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posNombre" />
          </div>

          <!-- TIPO DOCUMENTO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-file-earmark-text fs-6 text-info me-2"></i> TIPO DOCUMENTO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="desDocumento" />
          </div>

          <!-- NRO DOCUMENTO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-credit-card fs-6 text-primary me-2"></i> N° DOCUMENTO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posNroDocumento" />
          </div>

          <!-- GENERO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-gender-ambiguous fs-6  me-2"></i> GENERO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="nomGenero" />
          </div>

          <!-- CORREO -->
          <div class="col-lg-4 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-envelope fs-6 text-primary me-2"></i> CORREO ELECTRONICO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posCorreo" />
          </div>

          <!-- ESTADO CIVIL -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-people fs-6 text-warning me-2"></i> ESTADO CIVIL:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="nomEstadoCivil" />
          </div>

          <!-- TELEFONO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-telephone fs-6 text-success me-2"></i> TELEFONO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posTelefono" />
          </div>

          <!-- TEL ADICIONAL -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-phone fs-6 text-success me-2"></i> TELEF. ADICIONAL:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posTelAdicional" />
          </div>

          <!-- FECHA NAC -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cake fs-6 text-danger me-2"></i> FECH. NACIMIENTO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posFecNacimiento" />
          </div>

          <!-- CANT HIJOS -->
          <div class="col-lg-1 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-people-fill fs-6 text-info me-2"></i> CANT HIJOS:
            </label>
            <input disabled type="number" class="form-control tamaños" v-model="form.posCanHijos" min="0" max="9" />
          </div>

          <!-- HIJOS MENORES -->
          <div class="col-lg-1 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person-standing fs-6 text-dark me-2"></i> {{ menor }} 18 AÑOS:
            </label>
            <input disabled type="number" class="form-control tamaños" v-model="form.posHijosMen" min="0" max="9" />
          </div>

          <!-- PAIS -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-geo-alt fs-6 text-danger me-2"></i> PAIS:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="nomPais" />
          </div>

          <!-- NACIONALIDAD -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-flag fs-6 text-danger me-2"></i> NACIONALIDAD:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="nomNacionalidad" />
          </div>

          <!-- DEPARTAMENTO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-map fs-6 text-info me-2"></i> DEPARTAMENTO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="ubiDepartamento" />
          </div>

          <!-- PROVINCIA -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-pin-map fs-6 text-warning me-2"></i> PROVINCIA:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="ubiProvincia" />
          </div>

          <!-- DISTRITO -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-pin-map-fill fs-6 text-danger me-2"></i> DISTRITO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="ubiDistrito" />
          </div>

          <!-- PERFIL PROFESIONAL -->
          <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person-workspace fs-6 text- me-2"></i> PERFIL PROFESIONAL:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posPerProfesional" />
          </div>

          <!-- ESTUDIOS SUPERIORES -->
          <div class="form-group col-lg-3 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-mortarboard fs-6 text-info me-2"></i> ESTUDIOS SUPERIORES:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posEstudios" />
          </div>

          <!-- GRADO ACADEMICO -->
          <div class="col-lg-4 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-award fs-6 text-warning me-2"></i> GRADO ACADEMICO:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="desGradoAcademico" />
          </div>

          <!-- OCUPACION -->
          <div class="form-group col-lg-3 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-briefcase fs-6 text-danger me-2"></i> OCUPACION:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posOcupacion" />
          </div>

          <!-- DIRECCION -->
          <div class="form-group col-lg-6 col-md-12">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-house-door fs-6 text-primary me-2"></i> DIRECCION:
            </label>
            <input disabled type="text" class="form-control tamaños" v-model="form.posDireccion" />
          </div>

          <!-- RENTA QUINTA -->
          <div class="col col-lg-2 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash-stack fs-6 text-success me-2"></i> ¿TIENES RENTA QUINTA?
            </label>
            <div class="form-check">
              <input disabled class="form-check-input" type="checkbox" v-model="form.posRentaQuinta" />
            </div>
          </div>




          <div class="col col-lg-11 col-sm-6 my-auto">
            <div class="d-flex my-0 mt-3">
              <a v-if="form.posAdjunto != 1" :href="url + form.posAdjunto.slice(45)
                " target="_blank" class="btn btn-info my-0">
                <i class="bi bi-cloud-download text-white fs-5"></i>
              </a>

              <p class="my-2 ms-2 mb-0 pb-0 tamaños" v-if="form.posAdjunto != 1">
                {{ adjuntoNombre }}
              </p>
              <p class="my-2 ms-2 mb-0 pb-0 tamaños" v-if="form.posAdjunto != 1 && adjuntoNombre == ''">
                {{ form.posAdjunto.slice(45)}}
              </p>
            </div>
          </div>




          <p v-if="form.posAdjunto != 1" class="text-danger  texto mx-2">
            (Solo se admite formatos pdf, jpg, jpeg, xlsx, docx, txt)
          </p>

          <p v-else class="text-danger texto">
            (Solo se admite formatos pdf, jpg, jpeg, xlsx, docx, txt)
          </p>

          <!--  -->


          <p class="col col-12 px-2 mt-2 texto">
            (*) Si tiene hijos menores a 18 años de edad, contará con un
            beneficio social de S/.102.50, en el caso de contar con hijos
            menores a 24 años cursando estudios comunicarse con su supervisor
            o personal de selección.
          </p>

        </div>
      </div>

      <!-- <div v-if="permisoVisualizador == 11" class="d-flex justify-content-center mt-3">
          <button  class="btn btn-success mx-2 mb-3 px-5 py-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              fill="currentColor"
              class="bi bi-save2 mx-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
              />
            </svg>
            GRABAR
          </button>
        </div> -->
    </form>

    <form action="" @submit.prevent="cambiarBancos">
      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div v-if="apagar" class="row gx-2 gy-2">
          
          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash fs-6 text-info me-2"></i> BANCO HABERES:</label>
            <input disabled type="text" class="form-control tamaños" aria-describedby="emailHelp"
              v-model="bancoHaberes" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin fs-6 text-success me-2"></i> MONEDA (HAB.):</label>
            <input disabled type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="monHaberes" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash-stack fs-6 text-danger me-2"></i> BANCO DE CTS:</label>
            <input disabled type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="bancoCts" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin text-warning fs-6 me-2"></i> MONEDA(CTS):</label>
            <input disabled type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="monCts" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-wallet2 fs-6 text-danger me-2"></i> SISTEMA DE PENSIONES:</label>
            <input disabled type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="sisPensiones" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-telephone fs-6 text-info me-2"></i>
              CONTACTO DE EMERGENCIA:</label>
            <input disabled type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="guar.contacto" />
          </div>

          <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-phone fs-6 text-primary me-2"></i> N° DE CELULAR:</label>
            <input disabled type="number" class="form-control tamaños" aria-describedby="emailHelp"
              v-model="guar.celular" />
          </div>

          <div class="col-lg-1 col-md-6 col-sm-12  d-flex justify-content-end  mt-4">
            <button v-if="permisoVisualizador == 2" type="submit" class="btn btn-success  mb-3 pe-3 py-1">
              <i class="bi bi-floppy fs-5"></i>
            </button>

            <button v-if="permisoVisualizador == 11 && guar.modIngreso == false" type="submit"
              class="btn btn-success    px-4 py-0 mt-1" :class="{ 'w-100': !isMobile, 'w-25': isMobile }">
              <i class="bi bi-floppy fs-5"></i>
            </button>
          </div>
        </div>

        <div v-if="!apagar" class="row gx-2 gy-2">
          <div class="col-lg-3 col-md-6">
            <label class="tamaño">BANCO HABERES:</label>
            <div>
              <select class="form-select tamaños" aria-label="Default select example" @change="bancoHab($event)">
                <option disabled selected>{{ bancoHaberes }}</option>
                <option v-for="banco in bancoHaber" :key="banco.id" :value="banco.parCorrelativo">
                  {{ banco.parDescripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-2 col-md-6">
            <label class="tamaño">MONEDA(HAB.):</label>
            <div>
              <select class="form-select tamaños" aria-label="Default select example" @change="moneda1($event)">
                <option disabled selected>{{ monHaberes }}</option>
                <option v-for="mone in moneda" :key="mone.id" :value="mone.parCorrelativo">Z
                  {{ mone.parDescripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <label class="tamaño">BANCO DE CTS:</label>
            <div>
              <select class="form-select tamaños" aria-label="Default select example" @change="bancoCts1($event)">
                <option disabled selected>{{ bancoCts }}</option>
                <option v-for="banco in banCts" :key="banco.id" :value="banco.parCorrelativo">
                  {{ banco.parDescripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-2 col-md-6">
            <label class="tamaño">MONEDA (CTS):</label>
            <div>
              <select class="form-select tamaños" aria-label="Default select example" @change="monedaCts1($event)">
                <option disabled selected>{{ monCts }}</option>
                <option v-for="mone in moneda" :key="mone.id" :value="mone.parCorrelativo">
                  {{ mone.parDescripcion }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <label class="tamaño">SISTEMAS DE PENSIONES:</label>
            <div>
              <select class="form-select tamaños" aria-label="Default select example" @change="pensiones1($event)">
                <option selected disabled>{{ sisPensiones }}</option>
                <option v-for="pensiones in sistemPension" :key="pensiones.id" :value="pensiones.parCorrelativo">
                  {{ pensiones.parDescripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <label class="tamaño">CONTACTO DE EMERGENCIA (APELLIDO Y NOMBRES):</label>
            <input v-if="!apagar" type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="guar.contacto" />
          </div>

          <div class="col-lg-2 col-md-6">
            <label class="tamaño">N° DE CELULAR:</label>
            <input v-if="!apagar" type="text" class="form-control tamaños" id="exampleInputEmail1"
              aria-describedby="emailHelp" v-model="guar.celular" />
          </div>

          <div class=" col-lg-1 col-md-6 d-flex justify-content-end mt-4">
            <button v-if="permisoVisualizador == 2" type="submit" class="btn btn-success mb-3 px-3 py-2">
              <i class="bi bi-floppy fs-5"></i>
            </button>

            <button v-if="permisoVisualizador == 11 && guar.modIngreso == false" type="submit"
              class="btn btn-success    px-4 py-1 mt-1" :class="{ 'w-100': !isMobile, 'w-25': isMobile }">
              <i class="bi bi-floppy fs-5"></i>
            </button>
          </div>
        </div>




      </div>

    </form>

    <p class="text-danger mx-3 mt-2" v-if="guar.bancoHaberes == '003' && (idEmpresa == 3 || idEmpresa == 4)"><span
        style="font-weight: 600;">OTRAS BANCAS:</span> <span class="text-danger"> Si tienes tu cuenta de haberes en
        otras bancas distintas al BCP/BBVA "podrías" recibir la transacción al día siguiente 1pm.</span></p>

    <p class=" mx-2 mt-3 mb-3 px-2 text-justify texto">
      En conformidad con lo dispuesto en la Resolución Ministerial N°
      242-2017-TR.<strong> DECLARO BAJO JURAMENTO</strong>, que mis datos
      personales registrados en el presente formulario son los correctos y
      validos. Realizo la presente declaración jurada manifestando que la
      información proporcionada es verdadera y autorizo la verificación de
      lo declarado. En caso de falsedad declaro haber incurrido en el
      <strong>delito contra la Fe Pública, falsificación de Documentos,
        (Articulo 427° del Código Penal, en concordancia con el Articulo
        IV inciso 1.7) "Principio de Presunción de Veracidad" del título
        preliminar de la Ley de Procesamiento Administrativo General, Ley
        N°27444.</strong>
      Al <strong>GRABAR </strong> la información doy por aceptado los
      datos enviados.
    </p>

  </div>


  <!-- <div v-if="permisoVisualizador == 11 " class="mx-4 mt-4">
        <button class="btn btn-white" @click="cambiar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            class="bi bi-pencil-square text-primary"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>
        </button>
      </div> -->


</template>


<script>
import Swal from 'sweetalert2'
import { mapActions, mapGetters } from "vuex";

export default {

  data() {
    return {
      idEmpresa: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",
      apagate: true,
      adjuntoNombre: "",
      nombreRecuperado: "",
      menor: "<",
      desDocumento: "",
      nomGenero: "",
      nomEstadoCivil: "",
      ubiDepartamento: "",
      ubiProvincia: "",
      ubiDistrito: "",
      nomPais: "",
      nomNacionalidad: "",
      apagar: true,
      desGradoAcademico: "",
      bancoCts: "",
      bancoHaberes: "",
      monCts: "",
      monHaberes: "",
      sisPensiones: "",
      muestra: true,


      form: {
        idPostulante: "",
        posTipDocumento: "",
        posNroDocumento: "",
        posUbigeo: "",
        posNombre: "",
        posApePaterno: "",
        posApeMaterno: "",
        posFecNacimiento: "",
        posGenero: "",
        posEstCivil: "",
        posTelefono: "",
        posTelAdicional: "",
        posPais: "",
        posNacionalidad: "",
        posPerProfesional: "",
        posAdjunto: "",
        posEstado: "",
        posOcupacion: "",
        posCorreo: "",
        posCanHijos: "",
        posDireccion: "",
        posHijosMen: "",
        posGradoAcademico: "",
        posEstudios: "",
        posRentaQuinta: ""


      },

      guar: {
        idIngreso: "",
        idSolxPostulante: "",
        bancoHaberes: "",
        monHaberes: "",
        bancoCts: "",
        monCts: "",
        sisPensiones: "",
        contacto: "",
        celular: "",


      },

      isdisabled: true,

      sistemPension: [],
      bancoHaber: [],
      moneda: [],
      banCts: [],
      provincia: [],
      distrito: [],
      gradoAcademico: [],
      permisoVisualizador: null,

    };
  },

  mounted() {



    this.permisoVisualizador = localStorage.getItem("idPerfil")


    this.axios.get("ParametroData/Parametro/2475").then((r) => {
      this.gradoAcademico = r.data;
    });

    this.axios.get("ParametroData/Parametro/2535").then(r => {
      this.sistemPension = r.data

    })


    this.axios.get("ParametroData/Parametro/7320").then(r => {
      this.bancoHaber = r.data

    })

    this.axios.get("ParametroData/Parametro/7317").then(r => {
      this.moneda = r.data

    })

    this.axios.get("ParametroData/Parametro/7361").then(r => {
      this.banCts = r.data
    })


    this.guar.idSolxPostulante = this.$route.params.ContratoSelect

    this.axios
      .get(
        "Contrato/ObtenerDatosContrato/" +
        this.$route.params.ContratoSelect
      )
      .then((r) => {
        console.log(r.data);
        this.idEmpresa = r.data[0].idEmpresa
        this.form.idPostulante = r.data[0].idPostulante;
        this.form.posApePaterno = r.data[0].posApellidoPaterno;
        this.form.posApeMaterno = r.data[0].posApellidoMaterno;
        this.form.posNombre = r.data[0].posNombre;
        this.form.posCorreo = r.data[0].posCorreo;
        this.form.posTelefono = r.data[0].posTelefono
        this.desDocumento = r.data[0].nombreDocumento;
        this.posTipDocumento = r.data[0].posTipDocumento;
        this.form.posGenero = r.data[0].posGenero;
        this.form.posNroDocumento = r.data[0].posNroDocumento;
        this.nomGenero = r.data[0].nomGenero;
        this.nomEstadoCivil = r.data[0].nomEstadoCivil;
        this.form.posEstCivil = r.data[0].posEstadoCivil;
        this.form.posTelAdicional = r.data[0].posTelAdicional;
        this.form.posPais = r.data[0].posPais;
        this.form.posFecNacimiento = r.data[0].posFechaNacimiento.slice(0, 10);
        this.form.posAdjunto = r.data[0].posAdjunto;
        this.form.posNacionalidad = r.data[0].posNacionalidad;
        this.form.posCanHijos = r.data[0].posCantidadHijos;
        this.form.posHijosMen = r.data[0].posHijosMenores;
        this.form.posEstudios = r.data[0].posEstudiosSuperiores;
        this.ubiDepartamento = r.data[0].ubiDepartamento;
        this.ubiProvincia = r.data[0].ubiProvincia;
        this.ubiDistrito = r.data[0].ubiDistrito;
        this.form.posUbigeo = r.data[0].posUbigeo;
        this.nomPais = r.data[0].nomPais;
        this.form.posPais = r.data[0].posPais;
        this.nomNacionalidad = r.data[0].nomNacionalidad;
        this.form.posGradoAcademico = r.data[0].gradoAcademico;
        this.desGradoAcademico = r.data[0].desGradoAcademico
        this.bancoCts = r.data[0].bancoCts
        this.bancoHaberes = r.data[0].bancoHaberes
        this.monCts = r.data[0].monCts
        this.monHaberes = r.data[0].monHaberes
        this.sisPensiones = r.data[0].sisPensiones
        this.form.posOcupacion = r.data[0].posOcupacion;
        this.form.posDireccion = r.data[0].posDireccion;
        this.form.posPerProfesional = r.data[0].posPerProfesional
        this.form.posRentaQuinta = r.data[0].posRentaQuinta

        this.guar.idIngreso = r.data[0].idMaeIngreso
        this.guar.bancoHaberes = r.data[0].codBancoHaberes;
        this.guar.monHaberes = r.data[0].codMonHaberes;
        this.guar.bancoCts = r.data[0].codBancoCts;
        this.guar.monCts = r.data[0].codMonCts;
        this.guar.sisPensiones = r.data[0].codSisPensiones
        this.guar.contacto = r.data[0].nomConEmergencia
        this.guar.celular = r.data[0].nroCelEmergencia;




      });
  },
  computed: {
    ...mapGetters('parametros', ['EstadoCiviles', 'Genero', 'Arreglar', 'DepartamentoDistrito', 'NacionEstado', 'PaisEstado']),
    ...mapGetters("users", [
      "Items",
      "Permisos",
      "Contratos",
      "Tecnologia",
      "Operaciones",
      "Sst",
      "Bienestar",
      "Nominas",
      "Tesoreria",
      "Contabilidad",
      "Postulante"
    ]),
  },
  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {

    ...mapActions('listadoPostulante', ['editar']),

    retrocedo() {
      window.history.back();
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },


    cambiar() {
      this.apagar = false;
    },

    activador() {
      this.isdisabled = !this.isdisabled
      this.muestra = !this.muestra
    },


    bancoHab(event) {

      this.guar.bancoHaberes = event.target.value
    },

    moneda1(event) {
      this.guar.monHaberes = event.target.value
    },
    bancoCts1(event) {
      this.guar.bancoCts = event.target.value
    },
    monedaCts1(event) {
      this.guar.monCts = event.target.value
    },
    pensiones1(event) {
      this.guar.sisPensiones = event.target.value
    },
    estado(event) {
      this.form.posEstCivil = event.target.value
      console.log(event.target.value)
    },
    Generos(event) {
      this.form.posGenero = event.target.value
      console.log(event.target.value)
    },
    Documentos(event) {
      this.form.posTipDocumento = event.target.value
      console.log(event.target.value)
    },

    Departamen(event) {
      console.log(event.target.value)
      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((datos) => {
          console.log(datos.data)
          this.provincia = datos.data
        });
    },

    Province(event) {
      this.axios
        .get(`DistritoData/Listar/${event.target.value}`)
        .then((datos) => {
          this.distrito = datos.data;
        });
    },

    Distrito(event) {
      this.form.posUbigeo = event.target.value
      console.log(event.target.value)
    },
    PaisDes(event) {
      this.form.posPais = event.target.value
    },

    Nacion(event) {
      this.form.posNacionalidad = event.target.value
      console.log(event.target.value)
    },

    cambiarBancos() {

      this.axios.put("Postulante/ModificarBancos", this.guar).then(r => {

        if (r.data) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Se Realizo los cambios',
            showConfirmButton: false,
            timer: 1500
          })
        }
      })
    },
  },
};
</script>

<style scoped>
.completa {
  width: 100%;
  margin-left: 1%;
  margin-right: 1%;
}


.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.bg-verde {
  background-color: rgb(19, 163, 38);
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaños {
  font-size: 0.65rem;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.texto {
  font-size: 0.65rem;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
